/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 17:37
 * @LastEditors: 苏梦觎 mengyu.su@ginlong.com
 * @LastEditTime: 2025-12-16 13:43:47
 * @FilePath: \glyun_web_Vue3\src\router\intelligentMaintenance.js
 * @Description: 智能运维路由
 */
import { getOtaConfig } from '@/const/ota';
const confirmConfig = getOtaConfig().confirmConfig || {}
const confirmMetaCOnfig = {
  confirmConfig,
  confirmOnEnter: true,
}
export default [
  {
    path: '/intelligentMaintenance',
    redirect: '/intelligentMaintenance/deviceAnalysis',
    name: 'intelligentMaintenance',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//设备分析
        path: 'deviceAnalysis',
        redirect: '/intelligentMaintenance/deviceAnalysis',
        name: 'intelligentMaintenanceDeviceAnalysis',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'intelligentMaintenanceDeviceAnalysisInverter',
            component: () => import('../views/intelligentMaintenance/deviceAnalysis/inverter/index.vue'),
            meta: {
              title: 'v2_device_inverter',
              routeAuthCode: 'A070000',
            }
          },
          {//采集器
            path: 'collector',
            name: 'intelligentMaintenanceDeviceAnalysisCollector',
            component: () => import('../views/intelligentMaintenance/deviceAnalysis/collector/index.vue'),
            meta: {
              title: 'v2_device_datalogger',
              routeAuthCode: 'A070001',
            }
          },
          {//逆变器
            path: 'diagnosisRecord',
            name: 'intelligentMaintenanceDeviceAnalysisDiagnosisRecord',
            component: () => import('../views/intelligentMaintenance/deviceAnalysis/diagnosisRecord/index.vue'),
            meta: {
              title: 'v2_device_analysis_diagnostic_records',
              routeAuthCode: 'A070002',
            }
          },
        ],
      },
      {//设备控制
        path: 'deviceControl',
        redirect: '/intelligentMaintenance/deviceControl',
        name: 'intelligentMaintenanceDeviceControl',
        children: [
          {//逆变器批量控制
            path: 'inverterBatchControl',
            name: 'intelligentMaintenanceDeviceControlInverterBatchControl',
            component: () => import('../views/intelligentMaintenance/deviceControl/inverterBatchControl/index.vue'),
            meta: {
              title: 'v2_device_analysis_inverter_batch_control',
              routeAuthCode: 'A070100',
            }
          },
          {//采集器批量控制
            path: 'collectorBatchControl',
            name: 'intelligentMaintenanceDeviceControlCollectorBatchControl',
            component: () => import('../views/intelligentMaintenance/deviceControl/collectorBatchControl/index.vue'),
            meta: {
              title: 'v2_device_analysis_datalogger_batch_control',
              routeAuthCode: 'A070101',
            }
          },
          {//带时间的逆变器批量控制（NMI）
            path: 'inverterNmiBatchControl',
            name: 'intelligentMaintenanceDeviceControlInverterNmiBatchControl',
            component: () => import('../views/intelligentMaintenance/deviceControl/inverterNmiBatchControl/index.vue'),
            meta: {
              title: 'v2_device_control_inverter_batch_control_nmi',
              routeAuthCode: 'A070102',
            }
          },
          {//AFCI数据采集
            path: 'afcIDataCollection',
            name: 'intelligentMaintenanceDeviceControlAfcIDataCollection',
            component: () => import('../views/intelligentMaintenance/deviceControl/afcIDataCollection/index.vue'),
            meta: {
              title: 'AFCI数据采集',
              routeAuthCode: 'A070103',
            }
          },
        ],
      },
      {//智能预警
        path: 'intelligentEarlyWarning',
        redirect: '/intelligentMaintenance/intelligentEarlyWarning/dataBoard',
        name: '/intelligentMaintenanceIntelligentEarlyWarning',
        children: [
          {//数据看板
            path: 'dataBoard',
            name: 'intelligentMaintenanceIntelligentEarlyWarningDataBoard',
            component: () => import('../views/intelligentMaintenance/intelligentEarlyWarning/dataBoard/index.vue'),
            meta: {
              title: 'v2_device_abnormal_warning_data_board',
              routeAuthCode: 'A070602',
            }
          },
          {//我的关注
            path: 'myConcern',
            name: 'intelligentMaintenanceIntelligentEarlyWarningMyConcern',
            component: () => import('../views/intelligentMaintenance/intelligentEarlyWarning/myConcern/index.vue'),
            meta: {
              title: 'v2_smart_warning_my_concerns',
              routeAuthCode: 'A070600',
            }
          },
          {//故障预警
            path: 'faultEarlyWarning',
            name: 'intelligentMaintenanceIntelligentEarlyWarningFaultEarlyWarning',
            component: () => import('../views/intelligentMaintenance/intelligentEarlyWarning/faultEarlyWarning/index.vue'),
            meta: {
              title: 'v2_export_record_fault_warning',
              routeAuthCode: 'A070601',
            }
          },
        ],
      },
      {//设备异常预警
        path: 'deviceAnomalyEarlyWarning',
        name: 'intelligentMaintenanceDeviceAnomalyEarlyWarning',
        component: () => import('../views/intelligentMaintenance/deviceAnomalyEarlyWarning/index.vue'),
        meta: {
          title: 'v2_device_abnormal_warning',
          routeAuthCode: 'A0704',
        }
      },
      {//设备升级
        path: 'deviceUpgrade',
        redirect: '/intelligentMaintenance/deviceUpgrade/collectorFirmwareExternal',
        name: 'intelligentMaintenanceDeviceUpgrade',
        children: [
          {//采集器固件(外)
            path: 'collectorFirmwareExternal',
            name: 'intelligentMaintenanceDeviceUpgradeCollectorFirmwareExternal',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/collectorFirmwareExternal/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_datalogger_firmware',
              routeAuthCode: 'A070208',
              ...confirmMetaCOnfig,
            }
          },
          {//采集器固件(内)
            path: 'collectorFirmwareInside',
            name: 'intelligentMaintenanceDeviceUpgradeCollectorFirmwareInside',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/collectorFirmwareInside/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_datalogger_firmware',
              routeAuthCode: 'A070200',
              ...confirmMetaCOnfig,
            }
          },
          {//采集器版本分布
            path: 'collectorVersion',
            name: 'intelligentMaintenanceDeviceUpgradeCollectorVersion',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/collectorVersion/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_datalogger_version',
              routeAuthCode:'A070201',
              ...confirmMetaCOnfig,
            }
          },
          {//采集器升级记录
            path: 'collectorUpgradeRecord',
            name: 'intelligentMaintenanceDeviceUpgradeCollectorUpgradeRecord',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/collectorUpgradeRecord/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_datalogger_upgrade_records',
              routeAuthCode:'A070202',
              ...confirmMetaCOnfig,
            }
          },
          {//逆变器固件(外)
            path: 'inverterFirmwareExternal',
            name: 'intelligentMaintenanceDeviceUpgradeInverterFirmwareExternal',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/inverterFirmwareExternal/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_inverter_firmware',
              routeAuthCode:'A070207',
              ...confirmMetaCOnfig,
            }
          },
          {//逆变器固件(内)
            path: 'inverterFirmwareInside',
            name: 'intelligentMaintenanceDeviceUpgradeInverterFirmwareInside',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/inverterFirmwareInside/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_inverter_firmware',
              routeAuthCode:'A070203',
              ...confirmMetaCOnfig,
            }
          },
          {//聚合固件(内)
            path: 'aggregatedFirmwareInside',
            name: 'intelligentMaintenanceDeviceUpgradeAggregatedFirmwareInside',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInside/index.vue'),
            meta: {
              title: 'v2_aggregated_firmware_internal',
              routeAuthCode:'A070216',
              ...confirmMetaCOnfig,
            }
          },
           {//聚合固件详情
            path: 'aggregatedFirmwareInsideDetail/:id',
            name: 'intelligentMaintenanceDeviceUpgradeAggregatedFirmwareInsideDetail',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInside/components/firmwareDetail.vue'),
            meta: {
              title: 'v2_ota_firmware_details',
            }
          },
          {//逆变器版本分布
            path: 'inverterVersion',
            name: 'intelligentMaintenanceDeviceUpgradeInverterVersion',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/inverterVersion/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_inverter_version',
              routeAuthCode:'A070204',
              ...confirmMetaCOnfig,
            }
          },
          {//逆变器升级记录
            path: 'inverterUpgradeRecord',
            name: 'intelligentMaintenanceDeviceUpgradeInverterUpgradeRecord',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/inverterUpgradeRecord/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_inverter_upgrade_records',
              routeAuthCode:'A070205',
              ...confirmMetaCOnfig,
            }
          },
          {//压力升级
            path: 'loopUpgrade',
            name: 'intelligentMaintenanceDeviceUpgradeLoopUpgrade',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/loopUpgrade/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_pressure_upgrade',
              routeAuthCode:'A070206',
              ...confirmMetaCOnfig,
            }
          },
          {//EPM固件(外)
            path: 'epmFirmwareExternal',
            name: 'intelligentMaintenanceDeviceUpgradeEpmFirmwareExternal',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/epmFirmwareExternal/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_epm_firmware',
              routeAuthCode:'A070210',
              ...confirmMetaCOnfig,
            }
          },
          {//EPM固件(内)
            path: 'epmFirmwareInside',
            name: 'intelligentMaintenanceDeviceUpgradeEpmFirmwareInside',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/epmFirmwareInside/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_epm_firmware',
              routeAuthCode:'A070209',
              ...confirmMetaCOnfig,
            }
          },
          {//EPM版本分布
            path: 'epmVersion',
            name: 'intelligentMaintenanceDeviceUpgradeEpmVersion',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/epmVersion/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_epm_version',
              routeAuthCode:'A070211',
              ...confirmMetaCOnfig,
            }
          },
          {//EPM升级记录
            path: 'epmUpgradeRecord',
            name: 'intelligentMaintenanceDeviceUpgradeEpmUpgradeRecord',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/epmUpgradeRecord/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_epm_upgrade_records',
              routeAuthCode:'A070212',
              ...confirmMetaCOnfig,
            }
          },
          {//BMS固件(外)
            path: 'bmsFirmwareExternal',
            name: 'intelligentMaintenanceDeviceUpgradeBmsFirmwareExternal',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/bmsFirmwareExternal/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_bms_firmware',
              routeAuthCode:'A070215',
              ...confirmMetaCOnfig,
            }
          },
          {//BMS固件(内)
            path: 'bmsFirmwareInside',
            name: 'intelligentMaintenanceDeviceUpgradeBmsFirmwareInside',
            component: () => import('../views/intelligentMaintenance/deviceUpgrade/bmsFirmwareInside/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_bms_firmware',
              routeAuthCode:'A070214',
              ...confirmMetaCOnfig,
            }
          },
        ],
      },
      {//任务管理
        path: 'taskManagement',
        redirect: '/intelligentMaintenance/taskManagement/otaUpgrade',
        name: 'intelligentMaintenanceTaskManagement',
        children: [
          {//OTA升级
            path: 'otaUpgrade',
            name: 'intelligentMaintenanceTaskManagementOtaUpgrade',
            component: () => import('../views/intelligentMaintenance/taskManagement/otaUpgrade/index.vue'),
            meta: {
              title: 'v2_task_management_ota_upgrade',
              routeAuthCode:'A070500',
            }
          },
        ],
      },
      {//智能分析
        path: 'intelligentAnalysis',
        redirect: '/intelligentMaintenance/intelligentAnalysis/fullHours',
        name: 'intelligentMaintenanceIntelligentAnalysis',
        children: [
          {//满发小时数
            path: 'fullHours',
            name: 'intelligentMaintenanceIntelligentAnalysisFullHours',
            component: () => import('../views/intelligentMaintenance/intelligentAnalysis/fullHours/index.vue'),
            meta: {
              title: 'v2_inverter_details_full_load_hours',
              routeAuthCode:'A070300',
            }
          },
          {//采集器信号
            path: 'collectorSignal',
            name: 'intelligentMaintenanceIntelligentAnalysisCollectorSignal',
            component: () => import('../views/intelligentMaintenance/intelligentAnalysis/collectorSignal/index.vue'),
            meta: {
              title: 'v2_export_record_datalogger_signal',
              routeAuthCode:'A070301',
            }
          },
        ],
      },
    ],
  },
]

